module.exports = __webpack_public_path__ + "img/left_quotation_mark.96cf4b59.svg";